import 'css-chunksrc/client/scenes/projectResourceActivation/infoResource/styles.scss';export default {
  "dataUser": "_dataUser_136c3_1",
  "profession": "_profession_136c3_9",
  "avatar": "_avatar_136c3_15",
  "name": "_name_136c3_25",
  "email": "_email_136c3_31"
};